// @react/hooks/useAuthnAuth.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { authnAuthStore } from '@core/stores';

/**
 * React hook for LoginRecord operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAuthnAuth } from '@react/hooks';
 *
 * const LoginRecordList = observer(() => {
 *   const store = useAuthnAuth();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAuthnAuth() {
  return authnAuthStore;
}
